import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SfdtHtmlMergeRequest, Template } from '../Models/template';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class TemplateService {
  headers: HttpHeaders = new HttpHeaders();
  clientId: any;
  public templateData: any = new Template();

  constructor(private http: HttpClient) {
    this.headers.set('Content-Type', 'application/x-www-form-urlencoded');
  }

  GetAllTemplateCategory() {
    return this.http.get<any>('Template/GetAllTemplateCategory', { headers: this.headers })
  }

  AddOrUpdateTemplate(template) {
    return this.http.post<any>('Template/AddEditTemplate', template, { headers: this.headers });
  }

  public GetTemplateById(templateId) {
    return this.http.get('Template/GetTemplateById?TemplateId=' + templateId + '', { headers: this.headers });
  }

  GetAllTemplateList() {
    return this.http.get<any>('Template/GetAllTemplateList', { headers: this.headers })
  }

  DeleteTemplate(templateId) {
    return this.http.get('Template/DeleteTemplate?TemplateId=' + templateId  , { headers: this.headers });
  }

  GetTempleteFilterlist() {
    return this.http.get<any>('Template/GetTempleteFilterlist', { headers: this.headers })
  }

  TemplateSetDefault(TemplateId,TemplateCategoryId, billingEntityId: string) {
    return this.http.get<any>('Template/TemplateSetDefault?TemplateId=' + TemplateId + '&TemplateCategoryId=' + TemplateCategoryId  + '&billingEntityId=' + billingEntityId, { headers: this.headers })
  }

  CreateDuplicateTemplate(templateId) {
    return this.http.get<any>('Template/CreateDuplicateTemplate?TemplateId=' + templateId + '' , { headers: this.headers })
  }

  DownloadTemplate(templateId) {
    return this.http.post<any>('Template/Download/' + templateId, { headers: this.headers })
  }

  UploadTemplate(templateId, file) {
    return this.http.post<any>('Template/Upload/' + templateId, file, { headers: this.headers })
  }

  public DownloadTemplatePDF(templateId) {
    return this.http.post('/Template/DownloadTemplatePDF?TemplateId=' + templateId + '', { headers: this.headers });
  }

  public GetTempletePreviwView() {
    return this.http.get('Template/GetTempletePreviwView?ClientId=' + 0 + '&JobId=' + 0, { headers: this.headers });
  }

  public GetFirmLogo() {
    return this.http.get('Template/GetFirmLogo', { headers: this.headers });
  }

  GetSfdtHtmlMerged(request: SfdtHtmlMergeRequest) {
    return this.http.post<any>('Template/GetSfdtHtmlMerged', request, { headers: this.headers });
  }

  GetAllTemplatesByBillingEntity(billingEntityId: String, TemplateCategoryId: number): Observable<any> {
    const url = `Template/GetInvoiceTemplatesByBillingEntity?billingEntityId=${billingEntityId}&TemplateCategoryId=${TemplateCategoryId}`;
    return this.http.get<any>(url, { headers: this.headers });
  }

  DeleteTemplateCategory(id, isDeleted) {
    return this.http.get<any>('TemplateCategory/DeleteTemplateCategory?TemplateCategoryId=' + id + '&isDeleted=' + isDeleted);
  }

  GetItemByTemplateCategoryId(id: string) {
    return this.http.get<any>('TemplateCategory/GetItemByTemplateCategoryId?TemplateCategoryId=' + id);
  }

  AddEditTemplateCategory(templatecategory) {
    return this.http.post<any>('TemplateCategory/AddEditTemplateCategory', templatecategory);
  }

  GetTemplateCategorybyId(id) {
    return this.http.get<number>('TemplateCategory/GetItemByTemplateCategoryId?TemplateCategoryId=' + id);
  }
}
